import { UI } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import * as NB from 'native-base';
import React from 'react';
import { Dimensions, LayoutChangeEvent } from 'react-native';

import { ProductsListBarTypes } from '../..';

export declare namespace ProductTooltipTypes {
  interface Props {
    product: ProductsListBarTypes.Product;
    direction: 'top' | 'bottom';
  }
}

export const ProductTooltip = ({ product, direction }: ProductTooltipTypes.Props) => {
  const { width: windowWidth } = Dimensions.get('window');

  const [boxLeft, setBoxLeft] = React.useState<number>(0);

  const validateIsOutOfScreen = (layoutEvent: LayoutChangeEvent) => {
    // @ts-expect-error
    const left = (layoutEvent.nativeEvent.layout.left || 0) as number;
    const width = layoutEvent.nativeEvent.layout.width;

    const endOfBox = left + width;

    const isOutOfScreen = endOfBox > windowWidth;

    if (isOutOfScreen) {
      const newLeft = windowWidth - endOfBox - 25;
      setBoxLeft(newLeft);
    }
  };

  return (
    <NB.Box
      style={{
        position: 'absolute',
        top: (direction === 'top' ? '-70px' : '20px') as any,
        left: boxLeft,
        right: 0,
        bottom: 0,
        alignItems: 'center',
      }}>
      <UI.Shadow level={1} testId="shadow">
        <NB.VStack
          backgroundColor={Color['neutral.white']}
          padding={Spacing['inset.nano']}
          space={Spacing['stack.quarck']}
          onLayout={validateIsOutOfScreen}>
          <NB.HStack space={Spacing['inline.nano']} justifyContent={'space-between'}>
            <UI.Text
              textTransform={'uppercase'}
              fontSize={Typography['fontsize.xs']}
              variant="semibold"
              color={'neutral.black'}>
              {product.label}
            </UI.Text>
            <UI.Text
              textTransform={'uppercase'}
              fontSize={Typography['fontsize.xs']}
              color={'neutral.dark'}>
              {product.percentageFormatted}
            </UI.Text>
          </NB.HStack>
          <NB.HStack
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <NB.Box
              w={'8px'}
              height={'8px'}
              background={product.color}
              borderRadius={'full'}
              mr={Spacing['inline.nano']}
            />
            <UI.Text
              textTransform={'uppercase'}
              fontSize={Typography['fontsize.xs']}
              variant="semibold"
              color={'neutral.dark'}>
              {Utils.Mask.Money(product.value)}
            </UI.Text>
          </NB.HStack>
        </NB.VStack>
      </UI.Shadow>
    </NB.Box>
  );
};
